// Calculate space between slides
export const calculateSpaceBetweenSlides = (spaceBetween?: string | number) => {
  if (typeof spaceBetween === 'string') {
    return spaceBetween
  } else if (typeof spaceBetween === 'number') {
    return `${spaceBetween}px`
  } else {
    return `0px`
  }
}
